module.exports = __webpack_public_path__ + "img/krušnapeč-min.8a26a218.png";